import { BookAIcon, FlaskConicalIcon, Grid3x3Icon, HistoryIcon, LayoutGridIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: 'Hands-On DNA & Genetics Classroom Labs',
    description: 'Printable PDF guides for classroom lab activities on DNA and heredity.',
    icon: FlaskConicalIcon,
  },
  {
    number: '2',
    title: 'Punnett Square & Pedigree Problem Bank with Answer Keys',
    description: 'Practice problems on Punnett squares and pedigrees, each with its answer key.',
    icon: Grid3x3Icon,
  },
  {
    number: '3',
    title: 'Illustrated Genetics Glossary & Vocabulary Cards',
    description: 'Key genetics terms with clear definitions and illustrations, plus printable vocabulary cards.',
    icon: BookAIcon,
  },
  {
    number: '4',
    title: 'Genetics Quick-Reference Charts & Diagram Pack',
    description: 'One-page charts and diagrams that summarize core genetics concepts for fast review.',
    icon: LayoutGridIcon,
  },
  {
    number: '5',
    title: 'Landmark Discoveries in Genetics: Timeline & Case Studies',
    description: 'A timeline of the key discoveries in genetics, with case studies of the people and experiments behind them.',
    icon: HistoryIcon,
  },
];
